export const localStoragevarNames = {
    userLogged: 'isUserLoggedIn',
    user: 'user'
}